<template>
  <div
    class="long-summary"
    data-wptv="fip-long-summary">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'FipLongSummary',
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .long-summary {
    color: $black;
    max-width: 800px;
    font-size: 18px;
    line-height: 1.33;
    letter-spacing: normal;
    font-stretch: normal;
    font-weight: normal;
    margin-top: 20px;
  }
</style>
